<template>
  <div>
    <tutorial-job />
    <question-template name="job" :showTutorials="tutorials" />
  </div>
</template>

<script>
import TutorialJob from "@/views/questions/person_type/Tutorial.vue";
export default {
  name: "Job",
  components: {
    TutorialJob,
  },
  computed: {
    tutorials() {
      return this.$store.getters["app/getApp"].showPersonTypeTutorial;
    },
  },
  methods: {},
};
</script>

<style></style>
